import Component from "@glimmer/component";
import { computed } from "@ember/object";
import dIcon from "discourse/helpers/d-icon";
import { i18n } from "discourse-i18n";
import Circle from "../../models/circle";

export default class CirclesPrivacyStatus extends Component {
  @computed("args.model.privacy_level", "args.extendedText")
  get text() {
    const [key] = this.privacyLevelData;

    const textType = this.args.extendedName ? "name" : "extended_name";
    return i18n(`discourse_circles.form.privacy_levels.${key}.${textType}`);
  }

  get icon() {
    const props = this.privacyLevelData[1];
    return props?.icon;
  }

  get privacyLevelData() {
    return Object.entries(Circle.PRIVACY_LEVELS).find((level) => {
      const props = level[1];
      return props.value === this.args.model.privacy_level;
    });
  }

  <template>
    <div class="circles-privacy-status" ...attributes>
      {{#if this.icon}}
        {{dIcon this.icon}}
      {{/if}}
      {{this.text}}
    </div>
  </template>
}
